/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//responsive
$(window).on('load resize', function(){
  let winW = $(window).width();
  let devW = 1140;
  if (winW <= devW) {
    $('body').addClass('sp');
  } else {
    $('body').addClass('pc');
  }
});

/*
$(window).on('load resize', function(){

  let pWrap = $('.ProductItem');
  let badge = $('.ProductItem__ImageWrapper .flair-badge-wrapper');
  let pImg = $('.ProductItem__Image');
  
  if($('body').hasClass('pc')){
    console.log("aaa");
    $(pWrap).hover(function(){
      $(this).find(badge).show();
      $(this).find(pImg).css('opacity', '0.7');
    }, function() {
      $(this).find(badge).hide();
      $(this).find(pImg).css('opacity', '1');
    });
  }
});
*/

//footerAccordion
$(function() {
  $('.Footer__Title').on('click', function () {
    $(this).next().slideToggle(300);
    $(this).toggleClass('open', 300);
  });
});

//salePosition
$(window).on('load', function (){
  $('.ProductItem__Label--onSale').parent('.ProductItem__LabelList').addClass('onSale');
});

//spLinebanner
$(window).on('scroll', function () {
  const footer = $('#shopify-section-footer').innerHeight();
  const point = window.pageYOffset;
  const docHeight = $(document).height();
  const dispHeight = $(window).height();

  if (point > docHeight-dispHeight-footer){
    $('.line-banner').addClass('is-none');
  } else {
    $('.line-banner').removeClass('is-none');
  }
});

window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
});